var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.rows.length > 0)?_c('highcharts',{key:_vm.hcKey,attrs:{"options":_vm.chartOptions}}):_c('chart-not-available',{attrs:{"if-is-mop":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }